// used for browser detection. Useful for exporting power point, which will only
// add dom image in Chrome or Firefox, IE will actually report browser === undefined

export const getBrowser = () => {
  let sBrowser;
  const sUsrAg = navigator.userAgent;

  if (sUsrAg.indexOf("Edge") > -1) {
    sBrowser = "Edge";
  }
  else if(sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Chrome";
  }
    else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Safari";
  } 
    else if (sUsrAg.indexOf("Opera") > -1) {
      sBrowser = "Opera";
  } 
    else if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Firefox";
  } 
    else if (sUsrAg.indexOf("MSIE") > -1) {
      sBrowser = "MSIE";
  }

  return sBrowser;
};



// WEBPACK FOOTER //
// ./src/utils/getBrowser.js